"use client";

import Image from "next/image";
import logoBlackNoBg from "@/assets/imgs/logo_black_no_bg.png";
import CircularProgress from "@/modules/components/commons/CircularProgress";
import {
  useContributeFeature,
  useJoinWishlist,
} from "@/modules/hooks/contactSupport/useContactSupport";

const IconProfile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-primary"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h3m-6-4h.01M9 16h.01"
    />
  </svg>
);

const IconReferral = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-primary"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 10V3L4 14h7v7l9-11h-7z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-6 6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-6-6a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
    />
  </svg>
);

const IconConnect = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-primary"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>
);

const IconAI = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-secondaryDark"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 11a1 1 0 110-2 1 1 0 010 2zm-3 0a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z"
    />
  </svg>
);

const IconInterview = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-secondaryDark"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

const IconManage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-secondaryDark"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 12h4m-4 4h4m-7-4h.01M9 16h.01"
    />
  </svg>
);

const IconChatSchedule = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-secondaryDark"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 16l.01-.01M10 16l.01-.01M13 16l.01-.01"
    />
  </svg>
);

const IconRealtime = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-12 w-12 text-secondaryDark"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
    />
  </svg>
);

// --- Feature Data ---
const candidateFeatures = [
  {
    icon: <IconProfile />,
    title: "Xây dựng Hồ sơ Ấn tượng",
    description:
      "Tạo CV chuyên nghiệp, nổi bật thế mạnh cá nhân để thu hút nhà tuyển dụng.",
  },
  {
    icon: <IconReferral />,
    title: "Giới thiệu CV, Nhận thưởng",
    description:
      "Chia sẻ cơ hội, giới thiệu ứng viên phù hợp và nhận phần thưởng hấp dẫn.",
  },
  {
    icon: <IconConnect />,
    title: "Kết nối Trực tiếp Doanh nghiệp",
    description:
      "Trao đổi, đặt lịch phỏng vấn và nhận phản hồi nhanh chóng từ nhà tuyển dụng.",
  },
];

const businessFeatures = [
  {
    icon: <IconAI />,
    title: "AI Sàng lọc & Đánh giá CV",
    description:
      "Tiết kiệm thời gian với AI phân tích, xếp hạng ứng viên theo độ phù hợp.",
  },
  {
    icon: <IconInterview />,
    title: "Hỗ trợ Phỏng vấn Chuyên nghiệp",
    description:
      "Dịch vụ phỏng vấn bởi chuyên gia của chúng tôi giúp đánh giá khách quan, chọn đúng người cho phòng ban mới của bạn.",
  },
  {
    icon: <IconManage />,
    title: "Quản lý Hồ sơ Trực quan",
    description:
      "Theo dõi, quản lý ứng viên dễ dàng qua giao diện thân thiện, hiệu quả.",
  },
  {
    icon: <IconChatSchedule />,
    title: "Chat & Lên lịch Phỏng vấn",
    description:
      "Tương tác trực tiếp, sắp xếp lịch hẹn thuận tiện ngay trên nền tảng.",
  },
  {
    icon: <IconRealtime />,
    title: "Thông báo Thời gian thực",
    description:
      "Cập nhật trạng thái ứng tuyển, lịch phỏng vấn tức thì, không bỏ lỡ thông tin.",
  },
];

// --- Feature Card Component ---
const FeatureCard = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => (
  <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center">
    <div className="mb-4">{icon}</div>
    <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
    <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
  </div>
);

const CommingSoon = () => {
  const {
    pending: joinWishlistPending,
    message: joinWishlistMessage,
    joinWishlist,
  } = useJoinWishlist();
  const {
    pending: contributeFeaturePending,
    message: contributeFeatureMessage,
    contributeFeature,
  } = useContributeFeature();
  return (
    <div className="min-h-screen flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <Image
            src={logoBlackNoBg}
            width={300} // Adjusted size
            height={95} // Adjusted size
            alt="Together Work Logo"
            className="mx-auto mb-6 w-40" // Centered and sized
          />
          <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-4 tracking-tight">
            Together Work Sắp Ra Mắt!
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Nền tảng kết nối Doanh nghiệp và Ứng viên thế hệ mới.{" "}
            <br className="hidden sm:block" />
            Khám phá cơ hội, xây dựng sự nghiệp mơ ước của bạn.
          </p>
          <p className="mt-4 text-gray-500">
            Chúng tôi đang nỗ lực hoàn thiện những tính năng tốt nhất.
          </p>
        </div>

        {/* Features Section */}
        <div className="mb-16">
          {/* Candidate Features */}
          <div className="mb-16">
            <h2 className="text-3xl font-semibold text-primary text-center mb-10">
              Dành cho Ứng viên
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              {candidateFeatures.map((feature, index) => (
                <FeatureCard key={`cand-${index}`} {...feature} />
              ))}
            </div>
          </div>

          {/* Business Features */}
          <div>
            <h2 className="text-3xl font-semibold text-secondaryDark text-center mb-10">
              Dành cho Nhà tuyển dụng
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {businessFeatures.map((feature, index) => (
                <FeatureCard key={`biz-${index}`} {...feature} />
              ))}
            </div>
          </div>
        </div>

        {/* Feedback Buttons */}
        <section className="w-full">
          <div className="px-3 md:px-10 lg:px-36 mb-10 grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-7 xl:gap-9">
            <a
              href="https://forms.gle/phDJLsKTTzD42pC4A"
              target="_blank"
              className="bg-primary hover:bg-primaryDark text-white font-bold py-3 px-4 rounded-md transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md flex justify-center items-center text-center"
            >
              Chia sẻ ý kiến của bạn về Together Work về tính năng của ỨNG VIÊN
            </a>
            <a
              href="https://forms.gle/AFDFwinE1wrqaqeU9"
              target="_blank"
              className="bg-secondary hover:bg-secondaryDark text-white font-bold py-3 px-4 rounded-md transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md flex justify-center items-center text-center"
            >
              Chia sẻ ý kiến của bạn về Together Work về tính năng của NHÀ TUYỂN
              DỤNG
            </a>
          </div>
        </section>

        {/* Wishlist Form Section */}
        <section className="mb-16 max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-purple-200">
          <h2 className="text-2xl font-semibold text-center text-primary mb-6">
            Nhận Thông Báo Sớm & Ưu Đãi!
          </h2>
          <p className="text-center text-gray-600 mb-6">
            Đăng ký để là người đầu tiên trải nghiệm và nhận ưu đãi đặc biệt khi
            Together Work ra mắt.
          </p>
          <form onSubmit={joinWishlist} className="space-y-4">
            <div>
              <label htmlFor="wishlist-email" className="sr-only">
                Email
              </label>
              <input
                id="wishlist-email"
                type="email"
                name="email"
                required
                placeholder="Nhập email của bạn"
                className="w-full px-4 py-2 border border-solid border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200 bg-white"
              />
            </div>
            <div>
              <label htmlFor="wishlist-role" className="sr-only">
                Bạn là
              </label>
              <select
                id="wishlist-role"
                required
                name="userRole"
                defaultValue="ROLE_UNSPECIFIED"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200 bg-white"
              >
                <option value="ROLE_UNSPECIFIED" disabled>
                  Bạn là...
                </option>
                <option value="ROLE_CANDIDATE">Ứng viên tìm việc</option>
                <option value="ROLE_EMPLOYER">Nhà tuyển dụng</option>
                {/* <option value="ROLE_UNSPECIFIED">Khác</option> */}
              </select>
            </div>
            <button
              type="submit"
              className="w-full bg-primary hover:bg-purple-700 text-white font-bold py-3 px-4 rounded-md transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md flex justify-center items-center"
            >
              {joinWishlistPending ? <CircularProgress /> : "Đăng ký nhận tin"}
            </button>
            <div className="w-full mt-1 transition-all duration-300">
              <span className="text-primary text-sm transition-all duration-300">
                {joinWishlistMessage}
              </span>
            </div>
          </form>
        </section>

        {/* Contribution Form Section */}
        <section className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-secondary">
          <h2 className="text-2xl font-semibold text-center text-secondaryDark mb-6">
            Góp ý Tính năng Bạn Mong muốn?
          </h2>
          <p className="text-center text-gray-600 mb-6">
            Ý kiến của bạn rất quan trọng! Hãy cho chúng tôi biết bạn muốn thấy
            tính năng nào nhất trên Together Work.
          </p>
          <form onSubmit={contributeFeature} className="space-y-4">
            <div>
              <label htmlFor="contribute-email" className="sr-only">
                Email
              </label>
              <input
                id="contribute-email"
                type="email"
                name="email"
                placeholder="Nhập email của bạn"
                className="w-full px-4 py-2 border border-solid border-gray-300 rounded-md focus:ring-2 focus:ring-secondaryDark focus:border-transparent transition duration-200 bg-white"
              />
            </div>
            <div>
              <label htmlFor="contribution-role" className="sr-only">
                Bạn là
              </label>
              <select
                id="contribution-role"
                required
                name="userRole"
                defaultValue="ROLE_UNSPECIFIED"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondaryDark focus:border-transparent transition duration-200 bg-white"
              >
                <option value="ROLE_UNSPECIFIED" disabled>
                  Bạn là...
                </option>
                <option value="ROLE_CANDIDATE">Ứng viên tìm việc</option>
                <option value="ROLE_EMPLOYER">Nhà tuyển dụng</option>
              </select>
            </div>
            <div>
              <label htmlFor="feature-suggestion" className="sr-only">
                Đề xuất tính năng
              </label>
              <textarea
                id="feature-suggestion"
                rows={4}
                required
                name="descriptionFeature"
                placeholder="Mô tả tính năng bạn mong đợi hoặc phản hồi về sản phẩm..."
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondaryDark focus:border-transparent transition duration-200 resize-none"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-secondary hover:bg-secondaryDark text-white font-bold py-3 px-4 rounded-md transition duration-300 ease-in-out transform hover:-translate-y-0.5 hover:shadow-md flex justify-center items-center"
            >
              {contributeFeaturePending ? <CircularProgress /> : "Gửi góp ý"}
            </button>
            <div className="w-full mt-1 transition-all duration-300">
              <span className="text-secondaryDark text-sm transition-all duration-300">
                {contributeFeatureMessage}
              </span>
            </div>
          </form>
        </section>

        {/* Footer */}
        <footer className="text-center mt-16 text-gray-500 text-sm">
          © {new Date().getFullYear()} Together Work. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

IconProfile.displayName = "IconProfile";
IconReferral.displayName = "IconReferral";
IconConnect.displayName = "IconConnect";
IconAI.displayName = "IconAI";
IconInterview.displayName = "IconInterview";
IconManage.displayName = "IconManage";
IconChatSchedule.displayName = "IconChatSchedule";
IconRealtime.displayName = "IconRealtime";
FeatureCard.displayName = "FeatureCard";
CommingSoon.displayName = "CommingSoon";
export default CommingSoon;
